export const familyPath = (pathname) => {
  return exactPath(pathname) || subPath(pathname);
};

export const subPath = (pathname) => {
  return window.location.pathname.startsWith(`${pathname}/`);
};

export const exactPath = (pathname) => {
  return window.location.pathname === pathname;
};

const router = {
  exactPath,
  familyPath,
  subPath,
};

export default router;
